var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-weight-bold text-truncate",style:({ fontSize: _vm.fontSize + 'px' })},[_vm._v("\n  "+_vm._s(_vm.units)),_c('sup',[_vm._v(_vm._s(_vm.cents))]),_c('span',[_vm._v(" "+_vm._s(_vm.currency))])])}
var staticRenderFns = []

export { render, staticRenderFns }